export enum EOrderShippingErrors {
  MISSING_BILLING_DETAILS = 'No Billing Details found.',
  MISSING_SHIPPING_DETAILS = 'No Shipping Details found.',
  NOT_A_CLIENT_INVOICE = 'Order is not a Client Invoice.',
  ORDER_CANCELLED = 'Order status is CANCELLED.',
  SHIPSTATION_EXISTS = 'Already Pushed Order.',
  IS_TRANSFER_ORDER = 'Order is classified as a `Transfer Order.`',
  IS_SHIPSTATION = 'Order is from Shipstation.',
  NOT_POSTED = 'Order is not allocated.',
}

export enum EOrderCarrierCode {
  UPS_WALLETED = 'ups_walleted',
  USPS = 'usps',
  STAMPS_COM = 'stamps_com',
  GLOBALPOST = 'globalpost',
}

export enum EOrderCarrierName {
  UPS_WALLETED = 'UPS by ShipStation',
  USPS = 'USPS',
  STAMPS_COM = 'Stamps.com',
  GLOBALPOST = 'GlobalPost',
}
